export default {
  allContacts: {
    data: null,
    loading: false,
    error: null,
  },

  currentContact: null,
  externalContacts: {
    data: null,
    loading: false,
    error: null,
  },
  deleteContact: {
    data: null,
    loading: false,
    error: null,
  },
  newContact: {
    data: null,
    loading: false,
    error: null,
    success: false,
  },
  updateExternalContactImage: {
    data: null,
    loading: false,
    error: null,
  },
  locateUser: {
    data: null,
    loading: false,
    error: null,
  },
  activeContacts: {
    data: null,
    loading: false,
    error: null,
  },
  activeExternalContacts: {
    data: null,
    loading: false,
    error: null,
  },
  referreesList: {
    data: null,
    loading: false,
    error: null,
  },
  addRemoveFavorite: {
    data: null,
    loading: false,
    error: null,
    success: false,
  },
  blockUnblock: {
    data: null,
    loading: false,
    error: null,
    success: false,
  },
  blockedContactList: {
    data: null,
    loading: false,
    error: null,
  },
  blockedByList: {
    data: null,
    loading: false,
    error: null,
  },
  favoriteContacts: {
    data: null,
    loading: false,
    error: null,
  },
};
